import {completionScoreBandColor} from '@hconnect/common/utils'

import {INACTIVE_BAR_COLOR} from '../consts'
import {DifficultySummaries, QuestionDifficulty} from '../types'

export const getCurrentDifficulty = ({basic, advanced}: DifficultySummaries) => {
  if (basic.answeredPositively < basic.questionCount) {
    return QuestionDifficulty.Basic
  }
  if (advanced.answeredPositively < advanced.questionCount) {
    return QuestionDifficulty.Advanced
  }
  return QuestionDifficulty.Excellence
}

export const completionScoreBarColor = (
  difficultySummaries: DifficultySummaries,
  questionDifficulty: QuestionDifficulty
): string => {
  const {answeredPositively, questionCount} = difficultySummaries[questionDifficulty]

  if (!questionCount) {
    return INACTIVE_BAR_COLOR
  }

  const percentage = (answeredPositively / questionCount) * 100

  return completionScoreBandColor(percentage)
}
